<template>
  <div class="home" v-loading="loading">
    <div id="swiperBox" class="swiperBox" v-bind:options="swiperOption" ref="mySwiper">
      <div class="swiper-slide slide-one" style="position: relative;">
        <swiper  v-bind:options="swiperChildOption" ref="myChildSwiper" style="width: 80%;">
          <swiper-slide class="swiper-slide" style="width: 100%;">
             <img src="../assets/img/banner2.png" alt="" style="width:100%;height: 100%;">
          </swiper-slide>
          <swiper-slide class="swiper-slide" style="width: 100%;">
             <img src="../assets/img/banner2.png" alt="" style="width:100%;height: 100%;">
          </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div> 
        </swiper>
          <div class="msg-box">
              <h3>一站式门到门跨境公路运输服务平台</h3>
              <p>-TIR运输、双清包税、物流工具-</p>
          </div>
         <div class="search-box" >
              <Search></Search>
         </div>
      </div>
      <div class="swiper-slide slide-two" >
        <div class="display-box">
          <display-list></display-list>
        </div>
         <div class="line-boxs">
          <line-box></line-box>
         </div>
      </div>
      <div class="swiper-slide slide-three">
         <div class="car-class-boxs">
          <car-class></car-class>
         </div>
      </div>
      <div class="swiper-slide slide-four">
         <div class="show-case-boxs">
            <show-case></show-case>
         </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Search from "../components/search.vue";
import displayList from "../components/displayList.vue";
import LineBox from "../components/line.vue";
import CarClass from "../components/CarClass.vue";
import ShowCase from "../components/ShowCase.vue";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    Search,
    displayList,
    LineBox,
    CarClass,
    ShowCase
  },
  data() {
    return {
      loading: false,
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
        }
      },
      swiperChildOption: {
                spaceBetween: 30,
                slidesPerView: 1, // 一屏显示的slide个数
                centeredSlides: true,// 居中的slide是否标记为active，默认是最左active,这样样式即可生效
                slideToClickedSlide: true,// 点击的slide会居中
                loop: true,// 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
                autoplay: {
                  delay: 5000, // 等5秒下一个
                  disableOnInteraction: false // 中间滑动一下，取消自动吗？
                },
               pagination: {
               el: '.swiper-pagination',
               clickable: true
             }, // 下按钮
              speed: 800, // 滑动时候动画的速度
              paginationClickable: true, // 下面按钮让点吗
              navigation: {
              prevEl: '.swiper-button-prev', // 左侧按钮
              nextEl: '.swiper-button-next' // 右侧按钮
             },
             watchSlidesProgress: true, // 开启这个参数来计算每个slide的progress
             watchSlidesVisibility: true,  // 先要开启watchSlidesProgress参数，如果开启watchSlidesVisibility，则会在每个slide增加一个指示该slide的progress值得classname
        on: {
        }
      }
    };
  },
  created() {},
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiperChild() {
      return this.$refs.myChildSwiper.swiper;
    }
  },
  mounted() {
      
  }
};
</script>
 
<style lang="scss" scoped>
/* .el-header {
  position: absolute;
} */
// .slide-one {
//   height: calc(100vh - 60px);
// }
.search-box {
  position: absolute;
  bottom: 30px;
  transform: translate(0%, -50%);
  z-index: 99;
  width: 100%;
}
.msg-box {
   position: absolute;
  top: 35%;
  left: 40%;
  transform: translate(0%, -50%);
  z-index: 99;
  width: 100%;
  h3 {
    font-weight: bolder;
    color: #fff;
    font-size: 28px;
  }
  p {
    color: #e6cb3c;
    font-weight: bolder;
    font-size: 28px;
  }
}
.display-box {
  // position: fixed;
  // transform: translate(0%, -42%);
  // z-index: 99;
  width: 100%;
  margin-top: 20px;
}
.line-boxs {
  // position: fixed;
  // transform: translate(0%, 60%);
  // z-index: 99;
  width: 100%;
  height: 380px;
}
.car-class-boxs {
  height: 100%;
  width: 100%;
}
.show-case-boxs {
  width: 100%;
}
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;
    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}
//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}
//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }
  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }
  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;
    span {
      color: #fff;
      font-size: 20px;
    }
  }
}
// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.swiperBox {
   background: url(../assets/img/b3.jpg) repeat center;
}
// .slide-two {
//   background: url(../assets/img/home_do.jpg) no-repeat center;
//   background-size: cover;
// }
// .slide-three {
//   background: url(../assets/img/home_anli.jpg) no-repeat center;
//   background-size: cover;
// }
//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }
    .el-divider {
      background-color: #fff;
      height: 3px;
      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }
    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;
      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }
      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }
      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}
.order {
  order: -1;
}
.order-img {
  order: 1;
}
</style>